import alasql from 'alasql';
import MobileDetect from 'mobile-detect';
import _ from 'lodash'

alasql.fn.toDate = epoch => {
	const dt = new Date(epoch);
	return new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
};
alasql.fn.getLanguage = s => s ? s.toLowerCase().substr(0, 2) : 'Unbekannt';

export const createSummaryLogTable = (logs) => {
	db.exec(`DROP TABLE IF EXISTS Log`);
	db.exec(`CREATE TABLE Log (
		serialNo STRING, timestamp Date, language STRING, mobile STRING, phone STRING, tablet STRING, userAgent STRING, os STRING, stickerId STRING, bundleNo STRING
	)`);

	db.tables.Log.data = [];

	_.mapValues(logs, v => {
		const md = new MobileDetect(v.userAgent);

		/*if (md.tablet() === "UnknownTablet") {
			console.log(v.userAgent, md.tablet());
		}*/

/*		if (v.userAgent.indexOf('HUAWEI') > 0) {
			if (!md.phone())
			console.log(v.userAgent, md.phone());
		}*/

		db.tables.Log.data.push({
			bundleNo: v.bundleNo,
			serialNo: v.serialNo,
			stickerId: v.stickerId,
			timestamp: new Date(v.timestamp),
			language: v.acceptLanguage.split(",")[0],
			mobile: md.mobile() ? md.mobile() : "PC/Mac",
			phone: md.phone(),
			tablet: md.tablet(),
			userAgent: md.userAgent(),
			os: md.os()
		});
	});
};

export const createStickerLogTable = (logs) => {

};

export const db = new alasql.Database();

export default db;


// WEBPACK FOOTER //
// ./src/db/aladb.jsx